module.exports = __webpack_public_path__ + "img/felc_cer.4f0f8fa6.jpg";